/* eslint-disable */
define([
  'underscore',
  'backbone'
],
function (_, Backbone) {
'use strict';

var hash = {};

function get(key) {
  return hash[key];
}

function set(key /*key or object*/, value) {
  if (_.isString(key)) {
    hash[key] = value;
    this.trigger('init:' + key, value);
  } else if (_.isObject(key)) {
    _.extend(hash, key);
    _.each(key, function(v, k) {
      this.trigger('init:' + k, v);
    }, this);
  }
}

function has(key) {
  return _.has(hash, key);
}

function attributes() {
  return _.clone(hash);
}

return _.extend({
    get         : get
  , set         : set
  , has         : has
  , attributes  : attributes
}, Backbone.Events);
});
